import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Landmark, LogOut, LayoutDashboard, FilePlus2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import api from "@/lib/api";

export const Navbar = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [brand, setBrand] = useState({ site_name: "Cheltenham Township", site_tagline: "Tax Filing Portal" });

  useEffect(() => {
    api.get("/settings/brand").then((res) => setBrand(res.data)).catch(() => {});
  }, []);

  const handleLogout = async () => {
    await logout();
    navigate("/login");
  };

  return (
    <header className="sticky top-0 z-50 bg-white/80 backdrop-blur-md border-b border-slate-200">
      <div className="max-w-6xl mx-auto px-6 h-16 flex items-center justify-between">
        <Link
          to={user?.role === "admin" || user?.role === "staff" ? "/admin" : "/dashboard"}
          className="flex items-center gap-3"
          data-testid="navbar-logo"
        >
          <span className="w-9 h-9 rounded-md bg-[#1E3A8A] flex items-center justify-center">
            <Landmark className="w-5 h-5 text-white" />
          </span>
          <div className="leading-tight">
            <p className="font-heading font-semibold text-slate-900 text-sm" data-testid="navbar-site-name">
              {brand.site_name}
            </p>
            <p className="text-xs text-slate-500">{brand.site_tagline}</p>
          </div>
        </Link>

        <div className="flex items-center gap-2">
          {user?.role === "merchant" && (
            <>
              <Button
                variant="ghost"
                size="sm"
                onClick={() => navigate("/dashboard")}
                data-testid="nav-dashboard-btn"
                className="text-slate-700"
              >
                <LayoutDashboard className="w-4 h-4 mr-1.5" /> Dashboard
              </Button>
              <Button
                size="sm"
                onClick={() => navigate("/file")}
                data-testid="nav-new-filing-btn"
                className="bg-[#1E3A8A] hover:bg-[#1E40AF] text-white"
              >
                <FilePlus2 className="w-4 h-4 mr-1.5" /> New Filing
              </Button>
            </>
          )}
          <div className="hidden sm:flex flex-col items-end mr-2 ml-2">
            <span className="text-sm font-medium text-slate-800" data-testid="nav-user-name">
              {user?.name}
            </span>
            <span className="text-xs text-slate-500 uppercase tracking-wide">{user?.role}</span>
          </div>
          <Button
            variant="outline"
            size="sm"
            onClick={handleLogout}
            data-testid="logout-btn"
            className="border-slate-300"
          >
            <LogOut className="w-4 h-4" />
          </Button>
        </div>
      </div>
    </header>
  );
};
